import { Form, Grid, Radio, Typography } from 'antd';
import type { TFunction } from 'i18next';
import type { JSX } from 'react';

const { useBreakpoint } = Grid;

interface FormItemRadioButtonGroupProps {
  name: string;
  title: string;
  options: {
    value: number;
    label: string;
  }[];
  t: TFunction;
}

export const FormItemRadioButtonGroup = (
  props: FormItemRadioButtonGroupProps
): JSX.Element => {
  const screens = useBreakpoint();
  return (
    <>
      <Typography.Title level={4}>{props.title}</Typography.Title>
      <Form.Item
        name={props.name}
        rules={[
          { required: true, message: props.t('validator.obligatoryField') },
        ]}
      >
        <Radio.Group
          style={{
            display: 'flex',
            flexDirection: screens.xs ? 'column' : 'row',
            gap: screens.xs ? 10 : 0,
          }}
        >
          {props.options.map((option) => (
            <Radio key={option.value} value={option.value}>
              {option.label}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
    </>
  );
};
